// extracted by mini-css-extract-plugin
module.exports = {"colorBackground":"Layout_colorBackground__jSLfY","colorBackgroundBottom":"Layout_colorBackgroundBottom__0Rv_X"};